import { format, subDays } from 'date-fns';

/**
 * Форматирует дату в формат YYYY-MM-DD для API
 */
export function formatDateForAPI(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

/**
 * Получает диапазон дат "последние 7 дней" (по умолчанию)
 */
export function getDefaultDateRange(): { from: Date; to: Date } {
  const to = new Date();
  const from = subDays(to, 6); // 7 дней включая сегодня
  return { from, to };
}
